import script from "./HighlightText.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__